module.exports = __webpack_public_path__ + "img/logo.298d3c08.png";